import { ReactNode } from 'react';

import classNames from 'classnames';

import { Spinner } from '@/components/shared/Spinner/Spinner';

import styles from './WithLoading.module.scss';

interface WithLoadingProps {
  isLoading: boolean;
  children: ReactNode;
  width?: string;
  height?: string;
  size?: number;
  color?: 'white' | 'blue';
  className?: string;
}

const WithLoading = ({
  children,
  isLoading,
  width,
  height,
  size = 1,
  color = 'blue',
  className = '',
}: WithLoadingProps) => {
  return isLoading ? (
    <div
      className={classNames(styles.container, className, 'animation-fade-in')}
      style={{ width, height }}
    >
      <Spinner size={size} color={color} />
    </div>
  ) : (
    <div className={className}>{children}</div>
  );
};
export default WithLoading;
